import { useSearchParams } from 'react-router-dom';
import { useShell } from '@/hooks/useShell';

/** Full-width centered hashtag strip (Task 14). Keeps current route context. */
export const PopularHashtagsStrip = () => {
  const { shell } = useShell();
  const [params, setParams] = useSearchParams();
  const hashtags = shell?.hashtags ?? [];

  if (!hashtags.length) return null;

  const active = (params.get('tag') || params.get('q') || '').replace(/^#/, '').toLowerCase();

  return (
    <section className="portal-popular-strip" aria-label="Популярные хэштеги">
      <strong>Популярные хэштеги</strong>
      <div className="portal-popular-tags">
        {hashtags.map((item) => {
          const bare = item.tag.replace(/^#/, '');
          const selected = active === bare.toLowerCase();
          return (
            <button
              key={item.id}
              type="button"
              className={selected ? 'is-active' : undefined}
              aria-pressed={selected}
              onClick={() => {
                const next = new URLSearchParams(params);
                if (selected) {
                  next.delete('tag');
                  next.delete('q');
                } else {
                  next.set('tag', bare);
                }
                setParams(next, { replace: true });
              }}
            >
              {item.tag.startsWith('#') ? item.tag : `#${item.tag}`}
              <b>{item.counter}</b>
            </button>
          );
        })}
      </div>
    </section>
  );
};
